/**
 * Toolbar chip that picks the operations-dashboard's lookback window
 * (24h/72h/7d/30d) from a dropdown menu, with a clear (delete) affordance
 * back to the 24h default.
 *
 * Contains:
 * - TimeFilterChip — default export
 */

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Chip from '@mui/material/Chip';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';

import { toolbarChipSx } from '@sophocles/data-grids/components/toolbar/toolbarStyles';

const HOURS_OPTIONS = [
  { value: 24, label: '24h' },
  { value: 72, label: '72h' },
  { value: 168, label: '7d' },
  { value: 720, label: '30d' },
];

export default function TimeFilterChip({ value, onChange }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const selected = HOURS_OPTIONS.find(o => o.value === value);
  const label = selected ? `Time: ${selected.label}` : 'Time';

  return (
    <>
      <Chip
        icon={<AccessTimeIcon sx={{ fontSize: 16 }} />}
        label={label}
        size="small"
        color={value !== 24 ? 'primary' : 'default'}
        variant={value !== 24 ? 'filled' : 'outlined'}
        onClick={e => setAnchorEl(e.currentTarget)}
        onDelete={value !== 24 ? () => onChange(null, 24) : undefined}
        sx={toolbarChipSx}
      />
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {HOURS_OPTIONS.map(opt => (
          <MenuItem
            key={opt.value}
            dense
            selected={value === opt.value}
            onClick={() => {
              onChange(null, opt.value);
              setAnchorEl(null);
            }}
          >
            <ListItemText primary={opt.label} primaryTypographyProps={{ fontSize: '0.8rem' }} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
